import { Country, License, LicenseBundle, PhonePrefix } from '@app/models';

export class Dealer {
  dealerId: string;
  masterUserId: string;
  businessName: string;
  vatNumber: string;
  contactFirstName: string;
  contactLastName: string;
  email: string;
  pec: string;
  phonePrefixId: string;
  phonePrefix: PhonePrefix;
  phoneNumber: string;
  address: string;
  city: string;
  zipCode: string;
  countryId: string;
  country: Country;
  notes: string;
  deleted: number;
  licenses?: License[];
  licenseBundles?: LicenseBundle[];

  constructor(params: DealerParams) {
    this.dealerId = params.dealerId;
    this.masterUserId = params.masterUserId;
    this.businessName = params.businessName;
    this.vatNumber = params.vatNumber;
    this.contactFirstName = params.contactFirstName;
    this.contactLastName = params.contactLastName;
    this.email = params.email;
    this.pec = params.pec;
    this.phonePrefixId = params.phonePrefixId;
    this.phoneNumber = params.phoneNumber;
    this.address = params.address;
    this.countryId = params.countryId;
    this.country = params.country;
    this.notes = params.notes;
    this.deleted = params.deleted;
    this.phonePrefix = params?.phonePrefix && new PhonePrefix(params?.phonePrefix);
    this.country = params.country && new Country(params?.country);
    this.licenses = params.licenses ? params.licenses.map((l) => new License(l)) : undefined;
    this.licenseBundles = params.licenseBundles ? params.licenseBundles.map((l) => new LicenseBundle(l)) : undefined;
  }
}

export interface DealerParams {
  dealerId?: string;
  masterUserId?: string;
  businessName?: string;
  vatNumber?: string;
  contactFirstName?: string;
  contactLastName?: string;
  email?: string;
  pec?: string;
  phonePrefixId?: string;
  phonePrefix?: PhonePrefix;
  phoneNumber?: string;
  address?: string;
  countryId?: string;
  country?: Country;
  notes?: string;
  deleted?: number;
  licenses?: License[];
  licenseBundles?: LicenseBundle[];
}
